<body>
  <section class="title-container text-center" id="imageBox">
    <h1 class="club-name">PROSTOVOLJNO GASILSKO DRUŠTVO HOTEDRŠICA</h1>
  
    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center mt-4">
      <div class="pgd-logo mx-md-3 my-3 my-md-0">
        <!-- <img src="/assets/images/organisations/firedepartment/logo.png" alt="Club Logo" class="img-fluid" style="max-width: 120px;"> -->
        <img 
        class="img-fluid" 
        ngSrc="/assets/images/organisations/firedepartment/logo.png"
        width="1920" height="1080"
        fetchpriority="high"
        priority
        alt="Aerial view of Hotedršica">
      </div>
    </div>
  
    <div class="d-flex justify-content-center align-items-center mt-3">
      <img 
      class="bg-img" 
      ngSrc="/assets/images/organisations/firedepartment/bcg1.jpg"
      width="1920" height="1080"
      fetchpriority="high"
      priority
      alt="Background of Firedepartment page">
    </div>
  </section>

<section id="navbar">
  <div id="orgBar" class="container-fluid">
    <button id="burger" (click)="toggleMenu()">☰</button>
    <div id="menu" [ngClass]="{ 'show': menuOpen }" class="text-center">
      <button class="org-button" (click)="scrollTo('news')">Novice</button>
      <button class="org-button" (click)="scrollTo('history')">Zgodovina</button>
      <button class="org-button" (click)="scrollTo('fire-equipment')">Gasilska Tehnika</button>
      <button class="org-button" (click)="scrollTo('gallery-section')">Galerija</button>
      <button class="org-button" (click)="scrollTo('events')">Dogodki</button>
      <button class="org-button" (click)="scrollTo('povezave')">Povezave</button>
      <button class="org-button" (click)="scrollTo('join-fire-department')">Pridruži se</button>
      <button class="org-button" (click)="scrollTo('club-details')">Vizitka</button>
    </div>
  </div>
</section>


<section id="history" class="history-container container">
  <h1 class="font-weight-bold club-name animated-title text-center mt-5" style="color: #D0291D;">ZGODOVINA</h1>
  <p class="animated-text">Prostovoljno gasilsko društvo Hotedršica je bilo ustanovljeno leta 1905. Spomladi leta 1924 se je pričela izgradnja gasilskega doma. Slavnostna otvoritev je potekala 28.6.1925.</p>
  <div class="images-wrapper">
      <img src="/assets/images/organisations/firedepartment/zgodovina1.png" alt="History Image 1" class="img-fluid rounded shadow animated-image left-image">
      <img src="/assets/images/organisations/firedepartment/zgodovina2.png" alt="History Image 2" class="img-fluid rounded shadow animated-image right-image">
  </div>
</section>



<section id="fire-equipment" class="container py-5">
    <h1 class="font-weight-bold club-name animated-title text-center mt-5" style="color: #D0291D;">GASILSKA TEHNIKA</h1>
    
    <!-- First Vehicle: GVV-1 -->
    <div class="row align-items-center mb-5">
        <div class="col-md-6  animated-image left-image">
            <h3>Vozilo GVV-1 (gasilsko vozilo z vodo - manjše)</h3>
            <p><strong>Tip podvozja:</strong> Iveco</p>
            <p><strong>Leto izdelave:</strong> 2004</p>
            <p><strong>Dolžina vozila:</strong> 6000 mm</p>
            <p><strong>Širina vozila:</strong> 1996 mm</p>
            <p><strong>Maksimalna nosilnost:</strong> 6300 kg</p>
            <p><strong>Motor:</strong> 4-valjni turbointercooler, 107 kW (146 KM - 2798 cm3)</p>
            <p><strong>Pogon:</strong> 4x2</p>
            <p><strong>Kapaciteta posadke:</strong> 7 gasilcev (6+1)</p>
        </div>
        <div class="col-md-6 text-center">
            <img src="/assets/images/organisations/firedepartment/truck.png" class="img-fluid rounded shadow animated-image right-image" alt="GVV-1">
        </div>
    </div>
    
    <!-- Second Vehicle: GVM-1 -->
    <div class="row align-items-center mb-5 flex-md-row-reverse">
        <div class="col-md-6  animated-image right-image">
            <h3>Vozilo GVM - 1 (vozilo za prevoz moštva)</h3>
            <p><strong>Tip podvozja:</strong> Renault Master</p>
            <p><strong>Leto izdelave:</strong> 2009</p>
            <p><strong>Namen:</strong></p>
            <ul>
                <li>Prevoz moštva (8+1)</li>
                <li>Tehnično reševanje</li>
            </ul>
            <p><strong>Oprema:</strong> Nosila, svetila, gasilni aparati, torba prve pomoči, dihalni aparati</p>
        </div>
        <div class="col-md-6 text-center">
            <img src="/assets/images/organisations/firedepartment/van.png" class="img-fluid rounded shadow animated-image left-image" alt="GVM-1">
        </div>
    </div>
    
    <!-- Third Vehicle: PMB Trailer -->
    <div class="row align-items-center mb-5">
        <div class="col-md-6 animated-image left-image">
            <h3>Priklopnik s prenosno motorno brizgalno PMB</h3>
            <p><strong>Leto izdelave:</strong> 2013</p>
            <p><strong>Namen:</strong> Prevoz prenosne motorne brizgalne in gasilske opreme</p>
        </div>
        <div class="col-md-6 text-center">
            <img src="/assets/images/organisations/firedepartment/pump.png" class="img-fluid rounded shadow animated-image right-image" alt="PMB Trailer">
        </div>
    </div>
</section>

<div class="curvy-container">
</div>

<section id="gallery-section" class="p-1" style="padding-top: 5rem;">
  <h1 class="font-weight-bold club-name animated-title">GALERIJA</h1>
  <div class="container">
    <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="fireImages" (thumbClick)="onThumbClick($event)"></gallery>
    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn button-74 mt-3" (click)="openAddSportsImagesModal()">
      <fa-icon class="fa-lg me-2" [icon]="faPlus"></fa-icon>Dodaj slike</button>
    <button *ngIf="imageSelected && (isOrgAdmin || isSuperAdmin)" (click)="deleteSelectedImage()" class="btn button-74 mt-3">
      <fa-icon class="fa-lg me-2" [icon]="faTrash"></fa-icon>Izbriši izbrano sliko
  </button>
  </div>
</section>

<section id="news" class="p-1 pt-5">
  <h1 class="club-name animated-title">NOVICE</h1>
  <!-- Content for events organized by the sports club -->
  <app-news-list 
  [organisation]="organisation" 
  [isSuperAdmin]="isSuperAdmin" 
  [isOrgAdmin]="isOrgAdmin" [news]="news"
  [totalNewsCount]="totalItems"
  (loadMoreClicked)="loadMoreNews()"
  (newsChanged)="handleNewsChanged()"
  ></app-news-list>
</section>

<section *ngIf="organisationId" id="events" class="p-1 pt-5">
  <h1 class="font-weight-bold club-name animated-title">DOGODKI</h1>
  <div class="container mt-5">
  <app-event-list 
  [allEvents]="allEvents" 
  [onOrganisationPage]="true" 
  [isOrgAdmin]="isOrgAdmin" 
  [isSuperAdmin]="isSuperAdmin" 
  [organisationID]="organisationId"
  (eventChanged)="handleEventChanged()"
  ></app-event-list>
</div>
</section>



<div class="curvy-container-inv"></div>

<section id="join-fire-department" class="join-fire-department p-5 my-5">
  <div class="container">
    <div class="row align-items-start">
      <div class="col-md-6 text-center">
        <img src="/assets/images/organisations/firedepartment/pridruzi_se.png" alt="Pridruži se gasilski mladini" class="img-fluid rounded shadow-lg w-100 animated-image left-image">
      </div>
      <div class="col-md-6 text-white d-flex flex-column">
        <div>
          <p class="fs-5 animated-text">V društvu želimo na čim bolj zabaven in poučen način vključiti naše mlajše člane v gasilske vrste. Če se vaš otrok želi naučiti kaj novega, ga vabimo, da se vpiše v PGD Hotedršica.</p>
          <p class="fs-5 animated-text"><strong>Starostne kategorije:</strong></p>
          <ul class="fs-5 animated-text">
            <li><strong>Gasilec pionir/ka:</strong> od 7 do 11 let</li>
            <li><strong>Gasilec mladinec/ka:</strong> od 12 do 16 let</li>
            <li><strong>Gasilec pripravnik/ca:</strong> od 16 do 18 let</li>
          </ul>
          <p class="fs-5 animated-text">Na vajah se mladina nauči prepoznavanja in uporabe gasilske opreme, vezanja različnih vozlov, izbire primernega gasilskega sredstva glede na gorljivo snov, osnov prve pomoči, sodelovanja, odgovornosti in dela v ekipi.</p>
          <div class="d-flex justify-content-center gap-2">
            <button (click)="openJoinFile()" class="btn button-74 animated-text">
              Prijavnica
            </button>
          </div>
        </div>
        <div class="row mt-4 g-2 flex-grow-1 animated-image right-image">
          <div class="col-6 col-md-3">
            <img src="/assets/images/organisations/firedepartment/otroci1.jpg" alt="Gasilska Mladina 1" class="img-fluid rounded shadow-lg w-100">
          </div>
          <div class="col-6 col-md-3">
            <img src="/assets/images/organisations/firedepartment/otroci2.jpg" alt="Gasilska Mladina 2" class="img-fluid rounded shadow-lg w-100">
          </div>
          <div class="col-6 col-md-3">
            <img src="/assets/images/organisations/firedepartment/otroci3.jpg" alt="Gasilska Mladina 3" class="img-fluid rounded shadow-lg w-100">
          </div>
          <div class="col-6 col-md-3">
            <img src="/assets/images/organisations/firedepartment/otroci4.jpg" alt="Gasilska Mladina 4" class="img-fluid rounded shadow-lg w-100">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="curvy-container"></div>

<section id="club-details" class="club-details p-2">
  <h1 class="font-weight-bold club-name animated-title text-center mt-5" style="color: #D0291D;">VIZITKA</h1>
  
  <div class="container mt-5 animated-text">
    <div class="row g-4">
      <div class="col-md-6 d-flex flex-column">
        <div class="card shadow-lg border-0 flex-grow-1">
          <div class="card-body">
            <h3 class="card-title mb-0" style="color: #D0291D;">Kontaktni Podatki</h3>
            <hr>
            <p class="fw-bold mb-1">{{organisation?.name}}</p>
            <p class="mb-2" *ngIf="organisation?.address">
              <fa-icon class="me-2" [icon]="faHouse" style="color: #D0291D;"></fa-icon>
              {{organisation?.address}}, {{organisation?.postalCode}}</p>
            <p class="mb-2" *ngIf="organisation?.email">
              <fa-icon class="me-2" [icon]="faEnvelope" style="color: #D0291D;"></fa-icon>
              {{organisation?.email}}</p>
            <p class="mb-2" *ngIf="organisation?.phone">
              <fa-icon class="me-2" [icon]="faPhone" style="color: #D0291D;"></fa-icon>
              {{organisation?.phone}}</p>
          </div>
        </div>
        <div class="card shadow-lg border-0 flex-grow-1 mt-3">
          <div class="card-body">
            <h3 class="card-title mb-3" style="color: #D0291D;">Vodstvo</h3>
            <hr>
            <div *ngIf="organisation?.leaders">
              <div *ngFor="let leader of organisation!.leaders">
                <div *ngIf="leader.role === 'Predsednik'">
                  <p><strong>Predsednik:</strong> {{ leader.name }}</p>
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
                <div *ngIf="leader.role === 'Poveljnik'">
                  <p><strong>Poveljnik:</strong> {{ leader.name }}</p>
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
                <div *ngIf="leader.role === 'Tajnik'">
                  <p><strong>Tajnik:</strong> {{ leader.name }}</p>
                  <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
        
            <!-- Toggle Button for Add Leader Form -->
            <div *ngIf="isOrgAdmin || isSuperAdmin" class="text-center mt-4">
              <button class="btn btn-primary" (click)="toggleAddLeaderForm()">
                {{ showAddLeaderForm ? 'Skrij obrazec' : 'Dodaj novega člana' }}
              </button>
            </div>
        
            <!-- Add Leader Section (Toggles on Button Click) -->
            <div *ngIf="showAddLeaderForm" id="add-leader" class="p-5">
              <h2 class="text-center font-weight-bold">Dodaj novega člana</h2>
              <div class="container mt-5">
                <div class="row justify-content-center">
                  <div class="col-md-6">
                    <form (ngSubmit)="onSubmitAddLeader()">
                      <div class="mb-3">
                        <label for="leaderName" class="form-label">Ime in priimek</label>
                        <input type="text" class="form-control" id="leaderName" [(ngModel)]="newLeader.name" name="name" required>
                      </div>
        
                      <div class="mb-3">
                        <label for="leaderRole" class="form-label">Vloga</label>
                        <select class="form-control" id="leaderRole" [(ngModel)]="newLeader.role" name="role" required>
                          <option value="Predsednik">Predsednik</option>
                          <option value="Poveljnik">Poveljnik</option>
                          <option value="Tajnik">Tajnik</option>
                        </select>
                      </div>
        
                      <div class="mb-3">
                        <label for="leaderEmail" class="form-label">Email</label>
                        <input type="email" class="form-control" id="leaderEmail" [(ngModel)]="newLeader.email" name="email" required>
                      </div>
        
                      <div class="mb-3">
                        <label for="leaderPhone" class="form-label">Telefon</label>
                        <input type="tel" class="form-control" id="leaderPhone" [(ngModel)]="newLeader.phone" name="phone" required>
                      </div>
        
                      <button type="submit" class="btn btn-success">Dodaj</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         
      </div>
      <div class="col-md-6">
        <div class="card shadow-lg border-0 h-100">
          <div class="card-body">
            <h3 class="card-title mb-0" style="color: #D0291D;">Namenitev Dohodnine</h3>
            <hr>
            <p>Vsi, ki oddajajo dohodninsko napoved v Sloveniji, lahko do 1,0 % odmerjene dohodnine namenijo nevladnim organizacijam.</p>
            <p>Na podlagi Zakona o dohodnini je Vlada Republike Slovenije v letu 2007 sprejela Uredbo o namenitvi dela dohodnine za donacije, tako lahko 1,0 % odmerjene dohodnine namenite tudi PGD Hotedršica, za kar bomo hvaležni.</p>
            <p>Oddaja obrazca je preprosta in je možna osebno ali po pošti, kot tudi elektronsko preko <a href="https://edavki.durs.si" target="_blank">spletnega obrazca</a>. Obrazec je potrebno oddati do 31. decembra leta, za katerega se dohodnina odmerja.</p>
            <p><strong>Podatki:</strong></p>
            <ul>
              <li><strong>PROSTOVOLJNO GASILSKO DRUŠTVO HOTEDRŠICA</strong></li>
              <li>Davčna številka: 38892014</li>
              <li>Hotedršica 11</li>
              <li>1372 Hotedršica</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 text-center flex-grow-1 d-flex align-items-center justify-content-center my-5">
      <img src="/assets/images/organisations/firedepartment/background3.jpg" alt="Fire Department" class="img-fluid rounded shadow-lg" style="max-width: 50%;">
    </div>
  </div>
  <div *ngIf="organisationId" id="report-section" class="card shadow-lg border-0 h-100 mt-3 animated-text container">
    <app-report-list [orgID]="organisationId" [isAdmin]="isOrgAdmin || isSuperAdmin"></app-report-list>
  </div>
</section>

<section id="povezave" class="povezave-container py-5">
  <h1 class="font-weight-bold club-name animated-title text-center mt-5" style="color: #D0291D;">POVEZAVE</h1>
  
  <div class="row justify-content-center mt-4">
    <!-- New wrapper div to group the cards -->
    <div class="card-group">
      <div class="col-md-4 mb-3 d-flex flex-column justify-content-center align-items-center">
        <a href="https://meteo.arso.gov.si/" class="link-card" target="_blank">
          <div class="card-content">
            <img src="/assets/images/organisations/firedepartment/arso.png" alt="Meteo Alarm" class="img-fluid img-povezave rounded mb-2 animated-image right-image">
          </div>
        </a>
        <a href="https://meteo.arso.gov.si/" target="_blank" class="card-link">
          <h3>Meteo alarm meteo.si</h3>
        </a>
      </div>

      <div class="col-md-4 mb-3 d-flex flex-column justify-content-center align-items-center">
        <a href="https://spin3.sos112.si/javno/zemljevid" class="link-card" target="_blank">
          <div class="card-content">
            <img src="/assets/images/organisations/firedepartment/sos.jpg" alt="Spin" class="img-fluid img-povezave rounded mb-2 animated-image right-image">
          </div>
        </a>
        <a href="https://spin3.sos112.si/javno/zemljevid" target="_blank" class="card-link">
          <h3>Spin SPIN (sos112.si)</h3>
        </a>
      </div>

      <div class="col-md-4 mb-3 d-flex flex-column justify-content-center align-items-center">
        <a href="https://gasilec.net/" class="link-card" target="_blank">
          <div class="card-content">
            <img src="/assets/images/organisations/firedepartment/gzs.png" alt="Gasilska Zveza Slovenije" class="img-fluid img-povezaverounded mb-2 animated-image right-image">
          </div>
        </a>
        <a href="https://gasilec.net/" target="_blank" class="card-link">
          <h3>Gasilska Zveza Slovenije</h3>
        </a>
      </div>
    </div>
  </div>
</section>

  
</body>